import { FC } from 'react';
import { useSnapshot } from 'valtio';
import ConnectionModal from '../components/ConnectionModal';
import SelectedConnectionStore from '../stores/slected-connection-store';
import {
  closeConnectionModal,
  getConnection,
} from '../utils/selected-connection-store-utils';

const UpdateConnectionContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { selectedConnectionType } = useSnapshot(SelectedConnectionStore);

  const connection = getConnection(selectedConnectionType);
  if (!connection) {
    return null;
  }

  const isModalVisible = !!selectedConnectionType;

  return (
    <ConnectionModal
      connection={connection}
      open={isModalVisible}
      onClose={closeConnectionModal}
    />
  );
};

export default UpdateConnectionContainer;
